"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var border = "1px solid ".concat((0, _index.cssColorValue)(_index.semanticColors.decorativeSubdued));
var Item = exports.Item = _styledComponents["default"].li.withConfig({
  displayName: "Item",
  componentId: "sc-jzntl3-0"
})(["", ";list-style-type:none;border-block-start:", ";border-inline-end:", ";border-inline-start:", ";&:last-child{border-block-end:", ";}"], (0, _index.rootStyle)(), border, border, border, border);